import store from '@/state/store';
import { editParticipant } from '@/api/project';
import { handleError } from '@/actions/common';
import { AccessLevel } from '@bimdata/definitions/const';
import projectSlice from '@/state/project.slice';
import { runBulk } from '../utils';

export default async (code: string, participants: string[], access: AccessLevel) => {
  const state = store.getState();

  try {
    const ids = await runBulk(
      participants,
      (uid) => editParticipant(code, uid, access).then(() => uid),
      (e) => handleError(e)
    );

    if (state.authentication.profile?.id && ids.includes(state.authentication.profile?.id)) {
      store.dispatch(
        projectSlice.actions.setAccess({
          code,
          access,
        })
      );
    }

    if (access == AccessLevel.OWNER) {
      if (state.projects.current?.access == AccessLevel.OWNER) {
        store.dispatch(
          projectSlice.actions.setAccess({
            code,
            access: AccessLevel.ADMIN,
          })
        );
      }
      const ownerParticipant = state.projects.current?.participants?.find(({ access }) => access === AccessLevel.OWNER);
      if (ownerParticipant) {
        store.dispatch(
          projectSlice.actions.setParticipantsAccessLevel({
            code,
            ids: [ownerParticipant.user.id],
            access: AccessLevel.ADMIN,
          })
        );
      }
    }

    store.dispatch(
      projectSlice.actions.setParticipantsAccessLevel({
        code,
        ids,
        access,
      })
    );
  } catch (error) {
    handleError(error);
    throw error;
  }
};